import React from 'react';
import { st, classes } from './FullScreenModalLayoutContent.st.css';
import { BaseModalLayout } from '../../../BaseModalLayout';
import { FullScreenModalLayoutContentProps } from '../../FullScreenModalLayout.types';
import { DATA_HOOKS } from '../../FullScreenModalLayout.constants';

const FullScreenModalLayoutContent = ({
  children,
  padding = false,
  dataHook,
  className,
}: FullScreenModalLayoutContentProps) => {
  return (
    <BaseModalLayout.Content
      dataHook={dataHook || DATA_HOOKS.fullScreenModalLayoutContent}
      className={st(classes.root, { padding }, className)}
    >
      {children}
    </BaseModalLayout.Content>
  );
};

FullScreenModalLayoutContent.displayName = 'FullScreenModalLayout.Content';

export { FullScreenModalLayoutContent };
